import React from 'react';
import CompMarquee from '../Components/CompMarquee';
import './UXaaS.css'; // Import the CSS file
import CompContentBlock from '../Components/CompContentBlock';
import { Grid } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle'; // Import Material-UI CheckCircle icon
import CompContactWidget from '../Components/CompContactWidget';
import UXImgUXAASFeature1 from '../Assets/Images/uxi-2025-uxaas-feature1.png';
import UXImgUXAASFeature2 from '../Assets/Images/uxi-2025-uxaas-feature2.png';
import UXImgUXAASFeature3 from '../Assets/Images/uxi-2025-uxaas-feature3.png';
import UXImgUXAASFeature4 from '../Assets/Images/uxi-2025-uxaas-feature4.png';
import UXImgUXAASFeature5 from '../Assets/Images/uxi-2025-uxaas-feature5.png';

function UXaaS() {
  return (
    <div className="uxaas-container"> {/* Add a class to the container */}
      <CompMarquee title="Design that Leverages Tech" subTitle="Design differently, increase your reach." />
      <CompContentBlock heading="UX-as-a-Service, UX Made Easier" subheading="Our unique UX-as-a-Service is a coordination between automation, AI, and human-powered design process to maximize innovation.">
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <img src={UXImgUXAASFeature1} alt="Our Mission" style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={12} md={8}>
            <h4>Extend Your UX Reach, Continuously Improve</h4>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div>
                  <strong>Build: </strong>Extend your design team with our centralized team and automation tools to build even more, faster.
                </div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div>
                  <strong>Test: </strong>Test your product with automated tools or live users.
                </div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div>
                  <strong>Improve: </strong>Create a culture of ongoing innovation as you gather insights.
                </div>
              </li>
            </ul>
          </Grid>
        </Grid>
      </CompContentBlock>
      <CompContentBlock heading="UX-as-a-Service Areas of Impact" subheading="Day One Capabilities">
        <Grid container spacing={2} style={{ marginBottom: '8px' }}>
          <Grid item xs={12} md={3}>
            <img src={UXImgUXAASFeature2} alt="Product Logo" style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={12} md={9}>
            <h4>Design Collaboration</h4>
            <p>You now have a design team, utilize these professionals to make design recommendations, build new design approaches or help you expand your product or service.</p>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div>
                  <strong>Create Design Requests: </strong>Send prototype requests, design reviews or other tasks to our internal UX team and
                </div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div>
                  <strong>Conduct Business and User Research: </strong>Gain insights on your users and business processes by engaging your users with our platform.
                </div>
              </li>
            </ul>
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{ marginBottom: '8px' }}>
          <Grid item xs={12} md={3}>
            <img src={UXImgUXAASFeature3} alt="Product Logo" style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={12} md={9}>
            <h4>AI Driven Usability Insights</h4>
            <p>Unlock a deeper understanding of your user experience with AI driven usability insights.</p>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div><strong>Automated Usability Analysis: </strong> Instantly surface usability issues across your product without expensive manual testing.</div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div><strong>Actionable Recommendations: </strong> Get clear, prioritized suggestions to improve user experience and boost engagement.</div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div><strong>Faster Decision-Making: </strong> Cut analysis time in half and focus your team on high-impact improvements.</div>
              </li>
            </ul>
          </Grid>
        </Grid>

        <Grid container spacing={2} style={{ marginBottom: '8px' }}>
          <Grid item xs={12} md={3}>
            <img src={UXImgUXAASFeature4} alt="Product Logo" style={{ width: '100%' }} />
          </Grid>
          <Grid item xs={12} md={9}>
            <h4>User Feedback and Design Sessions</h4>
            <p>Capture real opinions, preferences, and pain points directly from your audience, and turn them into powerful design improvements.</p>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div><strong>Direct User Insights: </strong>Gather authentic feedback from real users to guide design decisions.</div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div><strong>Streamlined Feedback Collection: </strong>Easily organize and prioritize user input for faster iteration.</div>
              </li>
              <li style={{ display: 'flex', alignItems: 'flex-start', lineHeight: '1.5' }}>
                <CheckCircleIcon style={{ marginRight: '8px', marginTop: '4px' }} />
                <div><strong>Real-World Validation: </strong>Test concepts early and often to avoid costly rework later.</div>
              </li>
            </ul>
          </Grid>
        </Grid>
      </CompContentBlock>
      <CompContentBlock heading="Get Rolling and Configure for Your Organization" subheading="We can tailor our service to give you the insights you need.">
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
            <img src={UXImgUXAASFeature5} alt="Our Mission" style={{ width: '100%' }} />
            </Grid>
            <Grid item xs={12} md={8}>
            <h4>Solve User Pain Points One by One with Company Specific UX Tooling</h4>
            <p>
            Using Company Specific UX Tooling, you're not stuck with one-size-fits-all solutions. Our platform adapts to your workflows, your users, and your product goals — allowing your team to isolate and address pain points systematically. Whether it's a minor friction or a major usability gap, you’ll have the tools to fix it fast and measure the impact instantly.
            </p>
            </Grid>
        </Grid>
      </CompContentBlock>
      <CompContactWidget />
    </div>
  );
}

export default UXaaS;
